import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../../Icon';
import Avatar from '../../Avatar';
import FieldsetList from '../FieldSetList';
import { ConversationBtn } from '../ConversationBtn';
import { isDesktop } from '../../../utils/mobileHelpers';
import { getProfileFieldsetList } from '../utils/getFieldset';
import { ALLOW_SOCIAL_CHAT_CREATION } from '../../../constants/chat';
import { enhance } from './enhance';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import { GATrackPageView } from '../../../gtag';

/*
 * TODO: move static strings to constants
 */
class Profile extends Component {
  componentDidMount() {
    GATrackPageView('Profile | Details');
  }

  handleAvatarChange = newAvatarFormData => {
    window.storage.setItem('edit-avatar-user-id', this.props.profile.id);
    this.props.saveAvatar(newAvatarFormData);
  };

  handleAvatarRemove = () => {
    this.props.saveUser({
      id: this.props.profile.id,
      removeAvatar: true,
    });
  };

  render() {
    const {
      children,
      saveUser,
      healthInterestsList,
      profile,
      editUserSending,
      errors,
      canEdit,
      canEditOwnPatient,
      intl: { formatMessage },
      saveUserRequestClear,
      loggedUserId,
    } = this.props;

    const {
      id,
      avatar,
      username,
      primaryPatientProfile,
      primaryProviderProfile,
      status,
      displayableName,
      teamActingUser,
    } = profile;

    const { thumbMiddle } = avatar || {};

    const nestedProfile = primaryPatientProfile || primaryProviderProfile || {};
    const hasActiveProfile = !status || status === 'joined';

    const { firstName } = nestedProfile;

    const fieldOptions = {
      ...profile,
      errors,
      healthInterestsList,
      hasActiveProfile,
      canEditOwnPatient,
    };

    return (
      <div styleName="content user-profile-content">
        <MetaHelmet title="pages.title.profile.details" />
        <div styleName="userAvatar" className="user-profile-avatar">
          <Avatar
            editable={canEdit}
            src={thumbMiddle}
            children={firstName || displayableName}
            onChange={this.handleAvatarChange}
            onRemove={this.handleAvatarRemove}
            loading={editUserSending}
            size={96}
          />
        </div>
        <div styleName="info">
          <div
            styleName="userName"
            className={classNames('pb3 flex', {
              'items-center justify-between': isDesktop(),
              'flex-column': !isDesktop(),
            })}
          >
            <div>
              <span>
                {teamActingUser && (
                  <Icon name="team" size={24} className="mr2 mb1" />
                )}
                <span className="user-profile-name mr1">{displayableName}</span>
              </span>
              {username && hasActiveProfile && !teamActingUser && (
                <span
                  styleName="colored user-profile-username"
                  className="user-profile-username"
                >
                  {username}
                </span>
              )}
            </div>

            {loggedUserId !== id &&
              !teamActingUser &&
              ALLOW_SOCIAL_CHAT_CREATION && <ConversationBtn userId={id} />}
          </div>

          <div styleName="user-profile-common">
            <FieldsetList
              fieldSetList={getProfileFieldsetList(
                teamActingUser,
                fieldOptions,
                formatMessage,
              )}
              onSave={data => saveUser({ ...data, id })}
              disabled={!canEdit}
              onCancelCallback={saveUserRequestClear}
              canEdit={canEdit}
            />
          </div>
          {children}
        </div>
      </div>
    );
  }
}

Profile.propTypes = {
  profile: PropTypes.object,
  saveUser: PropTypes.func,
  editUserSending: PropTypes.bool,
  errors: PropTypes.object,
  healthInterestsList: PropTypes.array,
  children: PropTypes.node,
  canEdit: PropTypes.bool,
  canEditOwnPatient: PropTypes.bool,
  saveAvatar: PropTypes.func,
  saveUserRequestClear: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  loggedUserId: PropTypes.number,
};

export default enhance(Profile);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/Profile/index.jsx